export default function report(Drupal, once) {
  jQuery(function ($) {
    // Check if the body has the class for content type 'report'
    if ($('body').hasClass('node--type-report')) {

      // Add the Back to Top button functionality only for report nodes
      $('body').append('<button id="back-to-top" style="display: none;">Back to Top</button>');
    }

    // Function to show or hide the button based on scroll position
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $('#back-to-top').fadeIn();
      } else {
        $('#back-to-top').fadeOut();
      }
    });

    // Function to scroll to the top when the button is clicked
    $('#back-to-top').click(function () {
      $('html, body').animate({scrollTop: 0}, 'slow');
      return false;
    });

    // Existing TOC toggle functionality
    $('.toc-toggle').on('click', function () {
      const $wrapper = $(this).closest('.is-sticked');
      $wrapper.toggleClass('is-expanded');
    });
  });
}
